/**
 * Created by mark on 11/12/2017.
 */



import React from 'react';
import { Row, Col, Card } from 'react-bootstrap'
export default class Authentication extends React.Component {
    constructor(props) {
        super();
        this.props = props;
        this.state = {
            finishedCheck:false
        };
    }

    componentWillMount() {
    }

    render() {
        return <div>
            <Row>
                <Col>
                    <br />
                    <br />
                    <Card body>
                        <br />
                        <center style={{ top: '-50px', marginLeft: '-75px', left: '50%', position: 'absolute' }}><img height="150px" src="./img/logos/languagenut/no-text-logo.png" /></center>
                        <br />
                        <br />
                        <center><h1 class="display-4" style={{ marginBottom: '10px' }}>Thank You!<br /><small><small></small></small></h1></center>
                        <br />
                        <p>Thank you for signing up for Languagenut. To get your school access to the resources we need a short call with you to set up Languagenut to align to your curriculum. Please email me on <a href="mailto:roisin@languagenut.com">roisin@languagenut.com</a> or <a href="https://www.languagenut.com/ie/book-a-demo-2/?no_redirect=true">click here</a> here to schedule a meeting.</p>

                        <b>Key Features</b>
                        <br />

                        <ul class="fa-ul">
                            <li><span class="fa-li"><i class="fas fa-check"></i></span><b>Primary, Secondary and EAL/ESOL</b> resources.</li>
                            <li><span class="fa-li"><i class="fas fa-check"></i></span>8,000 exam-style questions - reading, writing, listening and speaking</li>
                            <li><span class="fa-li"><i class="fas fa-check"></i></span>Pre-made assignments - <b>over 300 hours of tasks ready for home learning</b></li>
                            <li><span class="fa-li"><i class="fas fa-check"></i></span>Resources in <b>French, Spanish, German, Mandarin, Italian + 20</b> more languages</li>
                            <li><span class="fa-li"><i class="fas fa-check"></i></span>2,500+ vocabulary items</li>
                            <li><span class="fa-li"><i class="fas fa-check"></i></span>Comprehensive grammar and verb activities</li>
                            <li><span class="fa-li"><i class="fas fa-check"></i></span>Sentence building games</li>
                            <li><span class="fa-li"><i class="fas fa-check"></i></span>Create your own content</li>
                            <li><span class="fa-li"><i class="fas fa-check"></i></span>Set assignment/homework</li>
                            <li><span class="fa-li"><i class="fas fa-check"></i></span>Comprehensive reporting, tracking and feedback for your students</li>
                        </ul>

                        <hr />
                        <p>
                            <center>
                                <span style={{ fontStyle: 'italic' }}>"I had half-forgotten that we were still in a trial period, such has been the success of Languagenut to date. It’s a real hit with both students and staff -everyone’s really bought into it, and it has a high profile in the school with weekly prize competitions and league tables in operation for highest performing student in each year group, plus end of half-term prizes for best student and class overall. The support offered by the team has also been excellent, and is appreciated. It would be difficult to imagine the department without Languagenut now!"</span>
                                <br />
                                <br />
                                <b>Danny Gleisner</b>
                                <br />
                                Head of MFL, Royds Academy
                            </center>
                        </p>
                        <center>
                            <small>For any questions email <a href="mailto:roisin@languagenut.com">roisin@languagenut.com</a></small>
                            <br /><img height="80px" src="https://s3-eu-west-1.amazonaws.com/marketing.languagenut.com/Sales%20site/Languagenut%20Sales%20Sites%20Image%20Assets/LN%20Logo.png" />
                        </center>
                    </Card>
                </Col>
            </Row>
        </div>
    }
}